module.exports = __webpack_public_path__ + "static/media/1m-gondola.4f9e8131.png";